export default __webpack_public_path__ + "static/media/logo.742afb28.png";